<template>
  <div>
    <div class="dk-home">
      <div class="p030">
        <!--活动内容模块-->
        <div class="dk-home-head">
          <div class="fc-bet">
            <div class="txt">
              <div class="h1">
                {{ activityData ? activityData.activityName :'签章活动' }}
              </div>
              <div class="sub">
                {{ activityData ? activityData.activityName :'签章活动' }}
              </div>
            </div>
            <div class="sign-wrap" @click="showcheckInBoxFun">
              <div class="sign-stadus sign-stadus2" ></div>
              <div class="sign-box fcc-h">
                <div class="num">
                  <span>{{ userFormData?userFormData:0 }}</span><span>/{{ activityData && activityData.sealDayNum ? activityData.sealDayNum : 0}}</span>
                </div>
                <div class="p">今日打卡</div>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="des">
            {{ activityData ? activityData.content :'活动规则' }}
          </div>
        </div>

        <!--优惠券模块-->
        <div class="dk-activity-links fc-bet">
          <div class="icon">
            <img src="../assets/icon90.png" alt="" />
<!--            <img :src="formData.product && formData.product.image?formData.product.image:''" alt="" />-->
          </div>
          <div class="txt flex1" @click="gotoCouponFun">
            您有<span class="b">{{ userCouponFormData.length }}</span>个活动券
          </div>
          <i class="link-arrow"></i>
        </div>

        <!--banner模块-->
        <div class="dk-home-card">
          <swiper :options="mySwiperOption" >
            <swiper-slide v-for=" i in 3" :key="i">
                <img src="../assets/690x480.png" alt="" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>

    <!--印章弹框-->
    <van-overlay :show="showcheckInBox" z-index="999" @click="showcheckInBox = false" @touchstart="handleTouchStart">
      <div class="fcc-h checkin-pop" style="height: 100vh;">
        <div class="fcc-h" style="width:90%;height: 45vh;" @click.stop>
          <div class="logo-wrap fcc">
            <div class="img fcc">
              <img src="../assets/logoicon.png" alt="" srcset="" />
            </div>
          </div>
          <div class="p fcc">
            请在屏幕上盖章
          </div>
        </div>
      </div>
    </van-overlay>

    <!--音效-->
    <div style="position:fixed;left: 110%;top: 110%;width: 0;height: 0;overflow: hidden">
			<audio id="audioID" ref="audio" class="aud">
				<source src="https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/images/duang.mp3" type="audio/mp3" />
			</audio>
		</div>
    <van-overlay :show="load" @click="load = false">
      <div class="fcc-h " style="height: 100vh;" @click="load = false">
        <div class="brand-logo fcc rotateing">
          <div class="circle"></div>
          <!-- <img src="../assets/8.png" alt="" v-if="zhang"/> -->
          <img src="../assets/logoicon.png" alt="" />
        </div>
      </div>
    </van-overlay>
    <!--loading-->
    <van-overlay :show="showLoading">
      <div class="fcc-h " style="height: 100vh;">
        <van-loading size="24px" vertical color="#fff">加载中...</van-loading>
      </div>
    </van-overlay>

  </div>
</template>

<script>
import {getRedeemList, getServiceStatus, queryActive, activeSignIn, queryActivityDetail} from "@/api/api";
import { check } from "@/utils/check"
import moment from "moment";
import {
  Swiper,
  SwiperSlide
} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  components: {Swiper,SwiperSlide},

  data() {
    return {
      activityData: null,
      showcheckInBox: false,
      showLoading: false,
      formData: {},
      productFormData: {},
      userFormData: 0,
      userCouponFormData: [],
      activityId: 0,
      checking: false,
      load: false,
      mySwiperOption: {
        direction: 'horizontal',
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
        autoplay: {
          delay: 5000, // 自动播放间隔时间，单位为毫秒
          disableOnInteraction: false, // 用户操作后是否停止自动播放，默认为true，设为false则不会停止
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //循环
        loop: true
      },
    }
  },
  async mounted() {
    this.showLoading = true
    const activityCode = window.localStorage.getItem('activityCode')
    console.log('活动',activityCode)
    if (!activityCode) {
      //提示
      this.$toast("活动已结束")
      this.showLoading = false
      return
    }
    // this.activityId = this.$route.query.activityId
    this.queryActivityDetailFun(activityCode)
    // this.getServiceStatusFun()
    this.$nextTick(() => {
			let Media = document.getElementById("audioID");
			Media.src = "https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/images/duang.mp3";
		})
  },
  methods: {
    moment,
    queryActivityDetailFun(code) {
      queryActivityDetail({activityCode:code}).then(res=>{
        this.showLoading = false
        this.activityData = res.data
      })
    },
    async getServiceStatusFun() {
      let res = await getServiceStatus(this.activityId)
      console.log(res);
      this.userFormData = res.data
    },
    async getRedeemListFun() {
      let res = await getRedeemList(this.formData.productId)
      this.userCouponFormData = res.data
    },
    gotoCouponFun() {
      console.log("this.userCouponFormData.length:", this.userCouponFormData.length)
      if(!this.userCouponFormData || this.userCouponFormData.length == 0){
        this.$toast("暂无活动券")
      }else{
        this.$router.push({ path: '/coupons?productId=' + this.formData.productId })
      }

    },
    showcheckInBoxFun() {
      console.log("showcheckInBoxFun")
      // if (this.userFormData >= this.formData.signatureTotalNum) {
      //   return
      // }
      this.showcheckInBox = true
    },
    async handleTouchStart(event) {
      if (event.touches.length != 4) {
        return
      }
      // 获取触摸点的坐标
      let touchArr = []
      for (let i = 0; i < event.touches.length; i++) {
        var touchX = event.touches[i].clientX;
        var touchY = event.touches[i].clientY;
        let touchItem = [touchX, touchY]
        touchArr.push(touchItem)
      }
      let scope = check(touchArr)
      console.log("盖章：", scope)
      if (!scope) {
        // that.$toast("打卡失败，请重试")
        return
      }
      if (scope) {
        if (this.checking) {
          return
        }
        this.checking = true
        this.showcheckInBox = false
        this.load = true
        let requestData = {
          activeId: this.activityId,
          signatureTime: moment().format('YYYY-MM-DD HH:mm:ss')
        }
        let res = await activeSignIn(requestData)
        if (res.success) {
          if (res.data == 1) {
            this.$toast("签到成功！")
          } else {
            this.$toast("签退成功！")
          }
          document.querySelector('audio').play()
					document.getElementById("audioID").play()
          this.load = false
          this.getServiceStatusFun()
        } else {
          this.$toast(res.message)
        }
        this.checking = false
      }
    },
    formatDateTime(date) {
      function padZero(num) {
        return num < 10 ? '0' + num : num;
      }

      var year = date.getFullYear();
      var month = padZero(date.getMonth() + 1); // 月份是从0开始的
      var day = padZero(date.getDate());
      var hours = padZero(date.getHours());
      var minutes = padZero(date.getMinutes());
      var seconds = padZero(date.getSeconds());

      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    }
  },


}
</script>

<style scoped="scoped" lang="less">
.brand-logo {
  width: 367px;
  height: 367px;

  margin: 50px auto 22px;
  position: relative;

  .circle {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: url(../assets/8bg.png) center no-repeat;
    background-size: contain;
  }

  img {
    position: relative;
    width: 205px;
    height: 205px;
    display: block;
    object-fit: contain;
  }
}

.rotateing {
  .circle {
    -webkit-animation: circle 3s linear infinite;
    animation: circle 3s linear infinite;
  }
}


@keyframes circle {
  0% {
    -webkit-transform: rotate(0) scale(1.5);
    transform: rotate(0) scale(1.5);

  }

  // 33% {
  // 	-webkit-transform: rotate(720deg) scale(1.5);
  // 	transform: rotate(720deg) scale(1.5);
  // }
  // 67% {
  // 	-webkit-transform: rotate(1080deg) scale(1.5);
  // 	transform: rotate(1080deg) scale(1.5);
  // }
  100% {
    -webkit-transform: rotate(720deg) scale(1.5);
    transform: rotate(720deg) scale(1.5);
  }
}
</style>
